import types from "./types";

const PostAPI = (payload) => ({type: types.API_POST, payload: payload});

export default {
    PostAPI,
}


// WEBPACK FOOTER //
// ./src/Store/Middleware/Backend/actions.js